<template>
  <div class="about" ref="mBox">
    <el-row style="padding-bottom: 60px">
      <el-image :src="require('../assets/image/aboutpage1.png')" style="margin-right: 50px" />
      <el-image :src="require('../assets/image/aboutpage2.png')" class="main-img" />
    </el-row>
    <vue-scroll style="width: 100%; height: calc(100% - 120px)">
      <div class="con">
        <p>
          “锦绣西南”是土家织锦数字化保护公益项目，秉持数字创新作为传统工艺赋能当代生活的纽带，
          <br />
          以“教育、参与、共创、⻓效”为理念，以可视化、数据库、AR/XR等数字化路径，
          <br />
          探索数字人文视域下的数字设计创新价值：
          <br />
          保存珍贵文化样本、讲述土锦造物智慧、重塑工艺社区生态。坚持可持续发展导向，建立公众与边缘群体的关怀。
        </p>
        <p style="margin: 60px 0">邮箱：155282517@qq.com</p>
        <p>
          共享于艺术高校数字图书馆，建构开源知识体验。
          <br />
          已完成100余名传承人、362种卡普、153家相关企业以及相关文献收录。
        </p>
      </div>
      <div class="con">
        <p class="title">…………………… # 部分信息来源 # ……………………</p>
        <p>
          《龙山县志》（清）
          <br />
          《武陵行》——费孝通
          <br />
          《土家族美术史》——阮璞
          <br />
          《土家织锦》——田明
          <br />
          《土家织锦传承人口述史研究》——杨洪林、樊祖原
          <br />
          《挑织成花——湘鄂西土家织锦文化研究》——叶洪光、李斌
          <br />
          《湖湘织锦》——汪为义、田顺新、田大年
          <br />
          《西兰卡普的传人 土家织锦大师和传承人口述史》——王文章
          <br />
          《湘西土家织锦矢量图典》——贺景卫
        </p>
      </div>
      <div class="con">
        <p class="title">…………………… # 致谢 # ……………………</p>
        <p>汪少碧（土家织锦代表性传承人）</p>
        <p>鲁艾华（土家织锦代表性传承人）</p>
        <p>余强、谢亚平、钱胜、曹恒、陈臻、唐启航、李海、杨茜茹</p>
      </div>
    </vue-scroll>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.about {
  font-family: SourceHanSansCNMedium;
  width: 100%;
  height: 100%;
  background-image: url('../assets/image/about-bj.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 130px;
  padding-left: 140px;
  padding-right: 50px;
  padding-bottom: 120px;
  position: absolute;
  top: 0;
  left: 0;
  font-size: 26px;
  line-height: 60px;
  letter-spacing: 4px;
  text-align: center;
  .con {
    margin-bottom: 80px;
    .title {
      color: #b6b6b6;
    }
  }
}
</style>
